import apiClient from './apiClient';

export interface FL020 {
  fl020_01: string; fl020_10: string; fl020_11: string; fl020_16: string; fl020_18: string;
  fl020_91: string; fl020_92: string | null; fl020_93: string;
}
export interface ListResponse { data: FL020[]; total: number; page: number; size: number; }

export const docSetupApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/doc-setup', { params })).data;
  },
  async get(code: string): Promise<FL020> {
    return (await apiClient.get(`/api/doc-setup/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { fl020_01: string; fl020_10: string; fl020_11: string; fl020_16: string; fl020_18: string }): Promise<FL020> {
    return (await apiClient.post('/api/doc-setup', data)).data;
  },
  async update(code: string, data: { fl020_10: string; fl020_11: string; fl020_16: string; fl020_18: string }): Promise<FL020> {
    return (await apiClient.put(`/api/doc-setup/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/doc-setup/${encodeURIComponent(code)}`);
  },
};
